import classnames from 'classnames/bind'
import React from 'react'
import { useTranslate } from 'react-polyglot'

import {
  ALL_NAME,
  BlogNavigationProps,
  getAllChecked,
} from '~/components/Navigation/BlogNavigation'
import Button, {
  ButtonType,
} from '~/components/Navigation/BlogNavigation/Button'

import { FILTER } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ListProps {
  className?: string
  title?: BlogNavigationProps['title']
  items?: BlogNavigationProps['categories']
}

function List({ className, title, items }: ListProps) {
  const t = useTranslate()
  const allChecked = getAllChecked(items)

  return (
    <div className={cx(css.List, className)}>
      <Button
        className={cx(css.button)}
        type={ButtonType.Inline}
        name={ALL_NAME}
        checked={allChecked}
      >
        {`${t(FILTER.ALL)} ${title ?? ''}`}
      </Button>
      {items?.length > 0 &&
        items?.map(({ key, value, checked }, index) => (
          <Button
            key={`${key}_${index}`}
            className={cx(css.button)}
            type={ButtonType.Inline}
            name={key}
            checked={checked}
          >
            {value}
          </Button>
        ))}
    </div>
  )
}

List.defaultProps = {}

export default List
